module.exports = __webpack_public_path__ + "static/img/Thumbs.c62baa7.db";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Thumbs.db
// module id = 652
// module chunks = 1